// extracted by mini-css-extract-plugin
export var infoItem = "_ul-2";
export var title = "_ul-0";
export var value = "_ul-1";